import { v4 as uuidv4 } from "uuid";

const ProjectItem = (props) => {
  const closeItemOverlay = () => {
    props.closeItem();
  };

  return (
    <div className="project-item__overlay">
      <div className="project-item__close" onClick={closeItemOverlay}>
        <i className="fa-solid fa-x"></i>
      </div>
      <div className="project-item">
        <div className="project-item__img-container">
          <img
            src={props.img}
            alt={`User interface preview for ${props.project}`}
          />
        </div>
        <div className="project-item__section">
          <div className="project-item__main">
            <div className="projects-item__info">
              <div className="projects__container--project-main">
                <h3>{props.project}</h3>
                <p>{props.description}</p>
              </div>
            </div>
            <div className="projects__container--project-tags">
              <h3>Tech Stack</h3>
              <div className="project-item__tag-container">
                {props.tags.map((tag) => {
                  const uniqueKey = uuidv4();

                  return (
                    <p
                      key={uniqueKey}
                      className="projects__container--project-tags-tag"
                    >
                      {tag}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="projects__container--project-link">
            <a
              aria-label={`Visit ${props.project} website`}
              className="projects__container--project-button"
              href={props.url}
              rel="noreferrer"
              target="_blank"
            >
              Visit Website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
